import { $syncedGraphContent } from "../../stores/graph/content.ts";

interface ExportJsonResult {
  downloadLink?: HTMLAnchorElement;
  jsonString: string;
}

export const exportGraphAsJson = async (): Promise<ExportJsonResult | null> => {
  const graphContent = $syncedGraphContent.get();

  if (!graphContent) {
    console.error("Graph content is not available");
    return null;
  }

  try {
    const jsonString = JSON.stringify(graphContent, null, 2);

    const downloadLink = document.createElement("a");
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);

    downloadLink.href = url;
    downloadLink.download = "graph.json";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    URL.revokeObjectURL(url);

    return {
      downloadLink,
      jsonString,
    };
  } catch (error) {
    console.error("Error exporting graph as JSON:", error);
    return null;
  }
};
